module.exports = function injectTapEventPlugin () {
  require('react/lib/EventPluginHub').injection.injectEventPluginsByName({
    "TapEventPlugin":       require('./TapEventPlugin.js')
  });
};



/*****************
 ** WEBPACK FOOTER
 ** ../~/react-tap-event-plugin/src/injectTapEventPlugin.js
 ** module id = 897
 ** module chunks = 0
 **/